function trimOrderBeforeAjax(order, cartItems, isAccessoryShop) {
  const _cartItems = trimCartItemsBeforeAjax(cartItems)
  const _order = JSON.parse(JSON.stringify(order)) // Clone. We want NO reference
  _order.configuration = trimConfigurationBeforeAjax(_order.configuration)
  _order.configuration.leasing = order.paymentType === 'leasing'
    ? { id: _order.leasing_price_range.id, security_deposit_id: _order.leasing_price_range.security_deposit_id, }
    : null

  return { ..._order, is_accessory_shop: isAccessoryShop, cart_items: _cartItems }
}

function trimConfigurationBeforeAjax(configuration) {
  return Object.fromEntries(
    Object.entries(configuration ?? {}).map(([key, option]) => {
      if (option === null) return [key, option]
      if (typeof option.image !== 'undefined') delete option.image
      if (typeof option.color_hex !== 'undefined') delete option.color_hex
      if (typeof option.image_url !== 'undefined') delete option.image_url
      if (typeof option.description !== 'undefined') delete option.description
      if (typeof option.description_title !== 'undefined') delete option.description_title
      if (typeof option.min_price !== 'undefined') delete option.min_price
      if (typeof option.min_price_leasing !== 'undefined') delete option.min_price_leasing

      if (key === 'model_year') {
        return [key, { id: option.id }]
      }

      if (key === 'variants') {
        return [key, { variant_id: option.variant_id }]
      }

      if (key === 'engine_transmission') {
        return [key, { id: option.id }]
      }

      if (key === 'chargings') {
        return [key, trimConfigurationCharginsBeforeAjax(configuration)]
      }

      if (key === 'extra_equipments') {
        return [key, option]
      }

      if (key === 'color') {
        return [key, { id: option.id }]
      }

      if (key === 'dealer_colors') {
        return [key, trimConfigurationDealerColorsBeforeAjax(configuration)]
      }

      return [key, option]
    })
  )
}

function trimCartItemsBeforeAjax(cartItems) {
  return cartItems.map(cartItem => cartItem.id)
}

function trimConfigurationDealerColorsBeforeAjax(configuration) {
  if (configuration.dealer_colors === 'undefined') {
    return null
  }

  const dealerColors = configuration.dealer_colors.filter(dealerColor => {
    return dealerColor.value > 0
  })

  return dealerColors.map(dealerColor => {
    return {
      id: dealerColor.id,
      value: dealerColor.value
    }
  })
}

function trimConfigurationCharginsBeforeAjax(configuration) {
  if (configuration.chargings === 'undefined') {
    return null
  }

  return Object.values(configuration.chargings).flat()
}

export { trimOrderBeforeAjax }
